import React from "react";

export default function Spacer({ height = 20 }: { height?: number }) {
  return <div style={{ marginTop: height }} />;
}
